import { useAuth } from "../../../../../context";
import { useMutation, useQuery } from "react-query";
import {
  SupplierQuestionnaireUpstreamTransportationAndDistribution
} from "../../../../../api/supplier-questionnaire/tabs/categories";

export const supplierQuestionnaireUpstreamTransportationAndDistributionKeys = {
  items: () => ["supplierQuestionnaireUpstreamTransportationAndDistributionItems"],
  preview: () => ["supplierQuestionnaireUpstreamTransportationAndDistributionPreviewData"]
};

export function useGetSupplierQuestionnaireUpstreamTransportationAndDistributionItems(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...supplierQuestionnaireUpstreamTransportationAndDistributionKeys.items(),
      params.queryParams.page, params.queryParams.size, params.queryParams.sort],
    () => callApi(SupplierQuestionnaireUpstreamTransportationAndDistribution.getUpstreamTransportationAndDistributionItems, params), config);
}

export function useAddSupplierQuestionnaireUpstreamTransportationAndDistributionItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(SupplierQuestionnaireUpstreamTransportationAndDistribution.addUpstreamTransportationAndDistributionItems, {
      questionnaireId,
      data
    }), config);
}

export function useUpdateSupplierQuestionnaireUpstreamTransportationAndDistributionItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data }) =>
    callApi(SupplierQuestionnaireUpstreamTransportationAndDistribution.updateUpstreamTransportationAndDistributionItem, {
      questionnaireId,
      recordId,
      data
    }), config);
}

export function useDeleteSupplierQuestionnaireUpstreamTransportationAndDistributionItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId }) =>
    callApi(SupplierQuestionnaireUpstreamTransportationAndDistribution.deleteUpstreamTransportationAndDistributionItem, {
      questionnaireId,
      recordId
    }), config);
}

export function useImportSupplierQuestionnaireUpstreamTransportationAndDistributionItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(SupplierQuestionnaireUpstreamTransportationAndDistribution.importUpstreamTransportationAndDistributionItems, {
      questionnaireId,
      data
    }), config);
}

export function useGetUpstreamTransportationAndDistributionPreviewData(previewId, params, config) {
  const { callApi } = useAuth();
  return useQuery([...supplierQuestionnaireUpstreamTransportationAndDistributionKeys.preview(),
      previewId, params.page, params.size],
    () => callApi(SupplierQuestionnaireUpstreamTransportationAndDistribution.getUpstreamTransportationAndDistributionPreviewData,
      { previewId, params }), config);
}